<div class="action-item">
  <div *ngIf="actionItem.state === IssueState.OPEN && actionItem.actionItemType === ActionItemType.ACTION_ITEM_NEW" class="action-item-open">
    Neues Issue erkannt:<br>
    <button class="openIssue" (click)="openNewIssueDialog($event)">
      {{ actionItem.title }}
    </button>
    <div class="action-item-footer">
      <div class="ai-generated">
        KI-generiert
      </div>
      <div class="action-item-actions">
        <mat-icon class="action-item-reject-icon"
                  (click)="rejectActionItem()">delete_outline
        </mat-icon>
        <mat-icon class="action-item-accept-icon" (click)="acceptActionItem()">done</mat-icon>
      </div>
    </div>
  </div>
  <div *ngIf="actionItem.state === IssueState.OPEN && actionItem.actionItemType === ActionItemType.ACTION_ITEM_UPDATE" class="action-item-open">
    Update zu einem Issue-Vorschlag erkannt:<br>
    <button class="openIssue" (click)="openNewIssueDialog($event)">
      {{ actionItem.title }}
    </button>
    <div class="action-item-footer">
      <div class="ai-generated">
        KI-generiert
      </div>
      <div class="action-item-actions">
        <mat-icon class="action-item-reject-icon"
                  (click)="rejectActionItem()">delete_outline
        </mat-icon>
        <mat-icon class="action-item-accept-icon" (click)="acceptActionItem()">done</mat-icon>
      </div>
    </div>
  </div>
  <div *ngIf="actionItem.state === IssueState.OPEN && actionItem.actionItemType === ActionItemType.ISSUE_UPDATE" class="action-item-open">
    Update zu einem Issue erkannt:<br>
    <button class="openIssue" (click)="handleIssueClicked($event)">
      {{actionItem.issueId}} {{ actionItem.title }}
    </button>
    <div class="action-item-footer">
      <div class="ai-generated">
        KI-generiert
      </div>
      <div class="action-item-actions">
        <mat-icon class="action-item-reject-icon"
                  (click)="rejectActionItem()">delete_outline
        </mat-icon>
        <mat-icon class="action-item-accept-icon" (click)="updateExistingIssue()">done</mat-icon>
      </div>
    </div>
  </div>
  <div *ngIf="actionItem.state === IssueState.ACCEPTED" class="action-item-accepted">
    <div class="indicator"
         [ngClass]="{
              bug: actionItem.issueType === 'BUG',
              task: actionItem.issueType === 'TASK',
              story: actionItem.issueType === 'STORY',
              }"
    ></div>
    <div class="action-item-accepted-content">
      <div class="action-item-accepted-title">
        <span class="issue-text"> {{ 'widgets.chat.newIssue' | translate }}</span>
        <button class="openIssue" (click)="handleIssueClicked($event)">
          {{ actionItem.title }}
        </button>
        wurde erstellt.
      </div>
      <div class="ai-generated">
        KI-generiert
      </div>
    </div>
  </div>
  <div *ngIf="actionItem.state === IssueState.REJECTED" class="action-item-rejected">
    <div class="action-item-rejected-content">
      {{ actionItem.title }} wurde abgelehnt.
    </div>
    <div class="ai-generated">
      KI-generiert
    </div>
  </div>
</div>

<div class="issuecard-hidden">
  <template #newBklIssue></template>
</div>
